interface T {
  (arg: any): (this: any, ...args: any[]) => void;
  cancel: () => void;
}

export const debounce = <F extends (...params: any[]) => void>(fn: F, ms = 300) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  } as T;
};

type asyncFunc<TResult> = (...params: any[]) => Promise<TResult>;

/**
 * Only the last promise is actually resolved. The rest will remain unresolved.
 * */
export const debounceAsync = <TResult>(func: asyncFunc<TResult>, waitMs = 300): asyncFunc<TResult> => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  return function (this: any, ...args: any[]): Promise<TResult> {
    return new Promise<TResult>(resolve => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        timeoutId = undefined;
        func.apply(this, [...args]).then(resolve);
      }, waitMs);
    });
  };
};
